import Spinner from './Spinner';

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Common/Spinner/index.js